import './DarkThemeControl.css';
import React, { useContext } from 'react';
import clsx from 'clsx';
import { handleAnalitics } from "../../utils/tealium";
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
const DarkThemeControl = _ref => {
  let {
    handleClick,
    value,
    label,
    analytics,
    params
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(commonStyles, rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "switch__field"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-small switch__text"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "switch"
  }, /*#__PURE__*/React.createElement("label", {
    title: label,
    "aria-label": label,
    tabIndex: 0,
    onKeyPress: event => {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        event.target.click();
      }
    }
  }, /*#__PURE__*/React.createElement("input", {
    title: label,
    "aria-label": label,
    defaultChecked: value,
    className: "fp__checkbox",
    type: "checkbox",
    value: value ? value.toString() : 'true',
    tabIndex: -1,
    onChange: e => {
      handleClick(!value);
      handleAnalitics({
        params: params,
        title: !value ? 'off' : 'on',
        objectParamName: "Dark Mode Param",
        objectParams: analytics
      });
    },
    id: "switch-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "switch__shape"
  }))))));
};
const commonStyles = "cpddl2r";
const ltrStyles = "l1bik6hy";
const rtlStyles = "r1neioj3";
export default DarkThemeControl;